/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const manufacturerIdLabel = 'Manufacturer ID';
export const nameLabel = 'Manufacturer Name';
export const rebateProgramLabel = 'Rebate Program';
export const quarterRangeLabel = 'Quarter';
export const invoiceStatusLabel = 'Invoice Status';
export const URAUsedLabel = 'URA Used';
export const invoiceNumberLabel = 'Invoice Number';
export const invoiceDateLabel = 'Invoice Date';
export const balanceDueLabel = 'Balance Due';
export const overriddenLabel = 'Overridden';
export const paidInFullLabel = 'Paid In Full';
export const estimatePrincipalDue = 'Estimate Principal Due';
export const numUnitsLabel = 'Enter Num of Units';
export const interestDueLabel = 'Enter Interest Due';
export const principalDueError =
  'You must enter number of units to calculate Principal Due.';
export const accountReceivableNDCDatailLabel = 'Accounts Receivable NDC Detail';
